import customerFeedbackReducer from './feedback'
import customerListReducer from './list'
import customerLoyaltyReducer from './loyalty'

export {customerFeedbackReducer, customerListReducer, customerLoyaltyReducer}



// WEBPACK FOOTER //
// ./app/reducers/customers/index.js